module.exports = __webpack_public_path__ + "static/media/8.33d50595.JPG";